


























import './VuMeter.scss'
import { generateRandomString } from '@/modules/common/utils'
import { isMobile } from 'mobile-device-detect'
import sleep from '@/testing/sleep'
import { defineComponent, computed } from '@vue/composition-api'
import VuScaleVertical from '@/assets/vu-scale-vertical.svg'
import { useVuMeters } from '../../compositions'
import { VuMeterStreamInfo } from '.'

export default defineComponent({
  name: 'VuMeter',
  components: {
    VuScaleVertical
  },
  props: {
    streams: {
      type: Array as () => VuMeterStreamInfo[],
      required: true
    },
    direction: {
      type: String,
      default: 'vertical'
    },
    showScale: {
      type: Boolean,
      default: true
    }
  },
  setup (props) {
    const streamIds = computed(() => props.streams.map((stream) => stream.streamId))
    return {
      ...useVuMeters(streamIds)
    }
  },
  data: () => ({
    refId: generateRandomString(),
    meter: null as null | HTMLCanvasElement,
    isMobile: isMobile
  }),
  async mounted () {
    // FIXME: VuMeter is disabled on mobile due to too high CPU load of current implementation.
    if (this.isMobile) return
    const meter = this.$refs[this.refId] as HTMLCanvasElement | undefined
    if (meter) {
      this.meter = meter
    }
    await this.requestRedraw()
  },
  beforeDestroy () {
    this.meter = null
  },
  methods: {
    calculateDecibelVolume (): number {
      let maxVumeter = -10000
      for (const stream of this.streams) {
        const vumeter = this.vumeters[stream.streamId]?.channelVolumes[stream.channel] ?? 0
        const tempDecibleVal = 20 * this.log10(vumeter)
        const volumeScaled = this.scale(stream.volume, 0, 100, -48, 0)
        const combined = tempDecibleVal + volumeScaled
        if (combined > maxVumeter) {
          maxVumeter = combined
        }
      }
      return maxVumeter
    },
    // eslint-disable-next-line max-lines-per-function
    async drawVolumeRect () {
      if (!this.meter) {
        await this.requestRedraw()
        return
      }
      const ctx = this.meter.getContext('2d')
      if (ctx === null) {
        await this.requestRedraw()
        return
      }
      const decibleVal = this.calculateDecibelVolume()
      const tempVal = this.scale(decibleVal, -45, 0, 0, 100)

      ctx.clearRect(0, 0, this.meter.width, this.meter.height)
      if (this.direction === 'horizontal') {
        const grd = ctx.createLinearGradient(0, 0, 100, 5)
        grd.addColorStop(0, '#16A34A')
        grd.addColorStop(0.85, '#16A34A')
        grd.addColorStop(0.9, '#ed8000')
        grd.addColorStop(1, 'red')
        // val = 100 is the end
        ctx.fillRect(0, 0, tempVal, 5)
        ctx.fillStyle = grd
      } else if (this.direction === 'vertical') {
        const grd = ctx.createLinearGradient(0, 0, 10, 100)
        grd.addColorStop(1, '#16A34A')
        grd.addColorStop(0.15, '#16A34A')
        grd.addColorStop(0.1, '#ed8000')
        grd.addColorStop(0, 'red')
        // -100 is the top
        ctx.fillRect(0, 100, 10, (tempVal * -1))
        ctx.fillStyle = grd
      }
      await this.requestRedraw()
    },
    async requestRedraw () {
      await sleep(100)
      if (this.meter) window.requestAnimationFrame(() => {
        this.drawVolumeRect().catch((error) => console.warn('vumeter draw error', error))
      })
    },
    log10 (x: number) {
      return Math.log(x)/Math.LN10
    },
    scale (num: number, in_min: number, in_max: number, out_min: number, out_max: number) {
      return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min
    }
  }
})
